<template>
  <span v-if="IsLogin">
    <v-card class="mx-auto">
      <v-navigation-drawer
        app
        fixed
        clipped
        v-if="drawer"
        permanent
        :temporary="$vuetify.breakpoint.xs"
      >
        <v-list>
          <v-list-group
            v-for="item in menu"
            :key="item.title"
            v-model="item.active"
            class="secondary lighten-4 mb-2"
            active-class="primary font-weight-bold white--text"
          >
            <template v-slot:activator>
              <v-icon size="18" class="mr-2">{{ item.icon }}</v-icon>
              <v-list-item-content class="font-weight-bold">
                {{ item.title }}
              </v-list-item-content>
            </template>
            <v-list-item
              dense
              v-for="child in item.items"
              :key="child.path"
              :to="child.path"
              class="white pl-10"
              active-class="font-weight-bold"
              @click="showMenu"
            >
              <v-icon size="18" class="mr-2">{{ child.icon }}</v-icon>
              <span>{{ child.title }}</span>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </span>
</template>

<script>
export default {
  props: {
    drawer: Boolean,
    showMenu: Function,
  },
  created() {
    this.current = window.location.hash.replace("#", "");
  },
  computed: {
    menu() {
      let menu = [];

      const das = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.dashboard"),
        active: false,
        items: [],
      };
      das.items.push({
        title: this.$t("menu.dashboard"),
        path: "/",
        icon: "mdi-image-filter-vintage",
      });
      if (das.items.length) {
        das.active = das.items.map((e) => e.path).includes(this.current);
        menu.push(das);
      }

      const acc = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.account"),
        active: false,
        items: [],
      };
      if (this.fnCheckMission(this.Session, [{ m: this.USER, p: this.READ }])) {
        acc.items.push({
          title: this.$t("menu.role"),
          path: "/role",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (this.fnCheckMission(this.Session, [{ m: this.USER, p: this.READ }])) {
        acc.items.push({
          title: this.$t("menu.user"),
          path: "/user",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.ACCOUNT, p: this.READ }])
      ) {
        acc.items.push({
          title: this.$t("menu.account"),
          path: "/account",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (acc.items.length) {
        acc.active = acc.items.map((e) => e.path).includes(this.current);
        menu.push(acc);
      }

      const post = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.post"),
        active: false,
        items: [],
      };
      if (this.fnCheckMission(this.Session, [{ m: this.POST, p: this.READ }])) {
        post.items.push({
          title: this.$t("menu.post"),
          path: "/post",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.TOPIC, p: this.READ }])
      ) {
        post.items.push({
          title: this.$t("menu.topic"),
          path: "/topic",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.HASHTAG, p: this.READ }])
      ) {
        post.items.push({
          title: this.$t("menu.hashtag"),
          path: "/hashtag",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (post.items.length) {
        post.active = post.items.map((e) => e.path).includes(this.current);
        menu.push(post);
      }

      const dis = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.discovery"),
        active: false,
        items: [],
      };
      if (
        this.fnCheckMission(this.Session, [{ m: this.BANNER, p: this.READ }])
      ) {
        dis.items.push({
          title: this.$t("menu.banner"),
          path: "/banner",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.DISCOVERY, p: this.READ }])
      ) {
        dis.items.push({
          title: this.$t("menu.discovery"),
          path: "/discovery",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (dis.items.length) {
        dis.active = dis.items.map((e) => e.path).includes(this.current);
        menu.push(dis);
      }

      const gift = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.gift"),
        active: false,
        items: [],
      };
      if (this.fnCheckMission(this.Session, [{ m: this.GIFT, p: this.READ }])) {
        gift.items.push({
          title: this.$t("menu.gift"),
          path: "/gift",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.ORDER, p: this.READ }])
      ) {
        gift.items.push({
          title: this.$t("menu.order"),
          path: "/order",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (gift.items.length) {
        gift.active = gift.items.map((e) => e.path).includes(this.current);
        menu.push(gift);
      }

      const set = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.setting"),
        active: false,
        items: [],
      };
      if (this.fnCheckMission(this.Session, [{ m: this.PUSH, p: this.READ }])) {
        set.items.push({
          title: this.$t("menu.push"),
          path: "/push",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (this.fnCheckMission(this.Session, [{ m: this.MINT, p: this.READ }])) {
        set.items.push({
          title: this.$t("menu.mint"),
          path: "/mint",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.SETTING, p: this.READ }])
      ) {
        set.items.push({
          title: this.$t("menu.setting"),
          path: "/setting",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (set.items.length) {
        set.active = set.items.map((e) => e.path).includes(this.current);
        menu.push(set);
      }

      const rep = {
        icon: "mdi-view-dashboard",
        title: this.$t("menu.report"),
        active: false,
        items: [],
      };
      if (this.fnCheckMission(this.Session, [{ m: this.POST, p: this.READ }])) {
        rep.items.push({
          title: this.$t("menu.report"),
          path: "/report",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (
        this.fnCheckMission(this.Session, [{ m: this.TRACKING, p: this.READ }])
      ) {
        rep.items.push({
          title: this.$t("menu.tracking"),
          path: "/tracking",
          icon: "mdi-image-filter-vintage",
        });
      }
      if (rep.items.length) {
        rep.active = rep.items.map((e) => e.path).includes(this.current);
        menu.push(rep);
      }

      return menu;
    },
  },
};
</script>
